module.exports = __webpack_public_path__ + "media/src/images/balloons/red_gradient-d4d435aed36334cb381f529cf9999f2e.jpg";